import React from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import baseStyles from './styles/baseStyles';
import Colours from '../tokens/colours';
import FontSizes from '../tokens/fontSizes';
const buttonSize = (fontSize, borderRadius) => ({
    borderRadius,
    fontSize,
});
const iconFill = disabled => {
    if (disabled) {
        return Colours.tertiary;
    }
    return Colours.primary;
};
const iconSize = (size) => size === 'small' ? '14' : '12';
const getStyles = createUseStyles({
    ...baseStyles,
    root: {
        padding: 4,
        lineSpacing: '2.4rem',
        backgroundColor: Colours.white,
        border: 'none',
        color: Colours.primary,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: Colours.tertiary,
        },
    },
    small: {
        ...buttonSize(FontSizes.Regular, 3),
    },
    mini: {
        ...buttonSize(FontSizes.Small, 3),
    },
    disabled: {
        backgroundColor: Colours.white,
        color: Colours.tertiary,
        '&:hover': {
            cursor: 'default',
            backgroundColor: Colours.white,
        },
    },
    icon: {
        marginRight: '8px',
    },
});
const CompactButton = ({ Icon, children, className, onClick, size, disabled = false, }) => {
    const styles = getStyles();
    return (React.createElement("button", { type: "button", className: classNames(styles.root, styles[size], {
            [styles.disabled]: disabled,
        }, className), onClick: onClick },
        Icon && (React.createElement(Icon, { fill: iconFill(disabled), width: iconSize(size), height: iconSize(size), viewBox: "0 0 20 20", className: classNames(styles.icon) })),
        children));
};
export default CompactButton;
//# sourceMappingURL=CompactButton.js.map